import { WidgetAutocheck, WidgetConfig } from "@redotech/redo-model/widget";
import { DEFAULT_TOGGLE_SELECTOR } from "../selectors";
import { getCartShadowRoot } from "../utils";

export function getReactElementFromPlacement({
  widgetConfig,
  autocheck,
}: {
  widgetConfig: WidgetConfig;
  autocheck: WidgetAutocheck;
}): Element[] {
  const docOrShadowRoot =
    getCartShadowRoot(autocheck, widgetConfig.shadowRootSelector) ?? document;

  return [
    ...Array.from(
      docOrShadowRoot.querySelectorAll(
        widgetConfig.placementSelector || DEFAULT_TOGGLE_SELECTOR,
      ),
    ),
  ];
}
